import ResidentialStatus, { type ResidentialStatusFieldProps } from '../../../components/fields/ResidentialStatusField';
import SelectField from './SelectField';

const ResidentialStatusField = (props: ResidentialStatusFieldProps) => (
    <ResidentialStatus SelectComp={SelectField} {...props} />
);

export default ResidentialStatusField;
